import { Session, SessionKeys } from 'common/services/-RFC.session.js';

const storeUrlParamLogic = ['$rootScope', '$location', '$window',
    ($rootScope, $location, $window) => {

        let path = decodeURIComponent($location.$$url);

        // save extra params reveived in url to be preserved
        // if language is changed or on page refresh
        const dashboardRoutes = [
            '/auth/login', '/auth/register', '/auth/forgot', '/auth/reset',
            '/auth/set-password', '/auth/tfa', '/auth/confirm', '/dashboard/subscriptions',
        ];
        const currentUrl = $window.location.href;

        Session.setValue(SessionKeys.InitalUrl, currentUrl);

        const [currentPath] =
        dashboardRoutes.filter(route => $location.path().indexOf(route) > -1);
        if (currentPath) {

            const index = currentUrl.indexOf(currentPath) + currentPath.length;
            const extraParams = currentUrl.substr(index);
            if (extraParams.length) {

                Session.setValue(SessionKeys.ExtraUrlParams, extraParams);

            }

        }
        // end

        if (path.indexOf('deviceid') > -1 || path.indexOf('referral/') > -1) {

        /**
         * @description
         * removes the 'deviceid/123' or 'referral/website' string
         * inputString = '/auth/login/otherparams/deviceid/id'
         * @example
         * // returns '/auth/login/otherparams'
         *
         */

            const paramToRemove = path.indexOf('deviceid') > -1 ? 'deviceid' : 'referral';
            const paramValue = path.slice(path.indexOf(paramToRemove)).split('/')[1];

            path = path.slice(0, path.indexOf(`/${paramToRemove}`)) +
            path.slice(path.lastIndexOf(paramValue) + paramValue.length);

            if (paramToRemove === 'deviceid') {

                Session.setValue(SessionKeys.DeviceId, paramValue);

            } else {

                Session.setValue(SessionKeys.ReferralCode, paramValue);

            }

            $location.url(path);

        } else if (path.indexOf('subscriptions') > -1 && path.indexOf('deploy') > -1) {

        /* check if the URL has "subscriptions" and "deploy" params.
        This is the shop purchase process. (Deploying paid apps) */

            const splitPathArray = path.split('/');

            const queryParams = $location.search();

            if (queryParams.appId) {

                const { appId } = queryParams;
                Session.setValue(SessionKeys.SubscriptionDeployAppId, appId);

            } else {

            // iterate through every parameter from url
                _.find(splitPathArray, (value, index) => {


                    if (value === 'subscriptions') {

                    // we need to check for this because the rewrite rule sometimes
                    // excecutes after the .run block where this logic is
                        const hasTabsSet = !!(splitPathArray[index + 1] === 'tabs');

                        if (hasTabsSet) {

                        // get the appId. We know that the appId
                        // is after subscriptions parameter
                        // "/subscriptions/tabs/plans/{appId}"
                            const appId = splitPathArray[index + 3];

                            // set appId
                            Session.setValue(SessionKeys.SubscriptionDeployAppId, appId);

                            return true;

                        } else if (!hasTabsSet) {

                        // get the appId. We know that the appId
                        // is after subscriptions parameter "/subscriptions/{appId}"
                            const appId = splitPathArray[index + 1];

                            // set appId
                            Session.setValue(SessionKeys.SubscriptionDeployAppId, appId);

                            return true;

                        }

                    }

                    return false;

                });

            }

        }

        if (path.indexOf('/dashboard') > -1) {

            // stores all URL params
            $rootScope.loginUrlRedirect = path;

            if ($location.hash()) {

                $rootScope.urlHash = $location.hash();

            }

            if (path.indexOf('/dashboard') > -1 && path.indexOf('/subscriptions') > -1) {

                Session.setValue(SessionKeys.ExtraUrlParams, path);

            }

        }

    }];

export default storeUrlParamLogic;



// WEBPACK FOOTER //
// ./scripts/app/storeUrlParamLogic.js